import React from 'react';
import IMAGES from '../imagesVariable/imagesVariable';
import './CitizenCharter.style.scss';
const CitizenCharter = () => {
  const specialPeopleData = [
    {
      id: 1,
      name: 'Dr. Abu Sayed Md. Mostafizur Rahaman',
      role: 'Teacher-in-Charge',
      img: IMAGES.AbuSayedMdMostafizurRahaman,
      link: 'asmmr@juniv.edu',

    },
    {
      id: 2,
      name: 'M Salahuddin Bhuiya',
      role: 'Additional Teacher-in-Charge',
      img: IMAGES.MSalahuddinBhuiya,
      link: 'salahuddin1976@juniv.edu',
    },
    {
      id: 3,
      name: 'Mohammad Ashraful Islam',
      role: 'Deputy Teacher-in-Charge',
      img: IMAGES.MohammadAshrafulIslam,
      link: 'ashraful.islam@juniv.edu',
    }
  ];

  const cardData = [
    {
      serviceName: "পাঠক সেবা",
      serviceMethod: "গ্রন্থাগার কার্ড প্রদানের মাধ্যমে",
      serviceTimes: ["Sun-Tue (9.00 AM - 4.00 PM)"],
      officers: [
        {
          name: "Md. Rezaul Haque",
          position: "Deputy Librarian",
          phone: "01927369402",
          email: "shuvohr97@gmail.com",
          ext: "7791045-51 (Ext. 1401)",
          img: IMAGES.MdRezaulHaque,
        },
      ],
    },
    {
      serviceName: "বই ইস্যু, জমাদান এবং ডিজিটাল আইডি কার্ড",
      serviceMethod: "গ্রন্থাগার কার্ড প্রদানের মাধ্যমে",
      serviceTimes: [
        "Sun-Tue (9.00 AM - 9.00 PM)",
        "Digital ID Card (9.00 AM - 4.00 PM)",
      ],
      officers: [
        {
          name: "Md. Faruk Hossain",
          position: "Technical Officer (Library)",
          phone: "01935928761",
          email: "faruk@juniv.edu",
          img: IMAGES.MdFarukHossain,
        },
        {
          name: "Shimul Kumar Barua",
          position: "Technical Officer (Library)",
          phone: "01731511729",
          email: "shimul.lib@juniv.edu",
          img: IMAGES.ShimulKumarBarua,
        },
      ],
    },
    {
      serviceName: "গবেষণা ও সংবাদ পত্র",
      serviceMethod: "গ্রন্থাগার কার্ড প্রদানের মাধ্যমে",
      serviceTimes: ["Sun-Tue (9.00 AM - 4.00 PM)"],
      officers: [
        {
          name: "Md. Bodiul Alam",
          position: "Assistant Librarian",
          phone: "01933320262",
          email: "bodiul.lib@gmail.com",
          img: IMAGES.MdBodiulAlam,
        },
      ],
    },
    
    {
      serviceName: "ক্যাটালগ, পুস্তক সংরক্ষণ ও অনলাইন সেবা",
      serviceMethod: "চাহিদা মোতাবেক",
      serviceTimes: ["Sun-Tue (9.00 AM - 4.00 PM)"],
      officers: [
        {
          name: "Md. Habibe Kibria Chowdhury",
          position: "Deputy Librarian",
          phone: "01812283752",
          email: "hkchowdhury016@juniv.edu",
          img: IMAGES.MdHabibeKibriaChawdhury,
        },
      ],
    },
    {
      serviceName: "অনলাইন সেবা ও বৈদ্যুতিক যন্ত্রপাতি",
      serviceMethod: "",
      serviceTimes: [],
      officers: [
        {
          name: "Md. Abdur Rahaman",
          position: "Programmer",
          phone: "01914553408",
          email: "tamal.lib@juniv.edu",
          img: IMAGES.MdAbdurRahaman,
        },
      ],
    },
    {
      serviceName: "প্রশাসনিক সেবা",
      serviceMethod: "",
      serviceTimes: ["Sun-Tue (9.00 AM - 4.00 PM)"],
      officers: [
        {
          name: "Mrs. Nazma Begum",
          position: "",
          phone: "01681676624",
          email: "nazmabegum.ju@gmail.com",
          img: IMAGES.NazmaBegum,
        },
        {
          name: "Md. Riaz Mahmud",
          position: "Administrative Officer",
          phone: "01717648547",
          email: "riazmahmud@juniv.edu",
          img: IMAGES.MdRiazMahmud,
        },
      ],
    },
  ];

  return (
    <div className="card-layout-container">


      {/* Special People Section */}

      <div className="special-people">
        {specialPeopleData.map((person, index) => (
          <div key={person.id} className={`special-person ${specialPeopleData.length % 2 !== 0 && index === 0 ? "centered" : ""
            }`}>
            <div className="profile">
              <img src={person.img} alt={`Profile of ${person.name}`} />
            </div>
            <div className="person-details">
              <h3>{person.name}</h3>
              <p>{person.role}</p>
              <a href={person.link}>{person.link}</a>

            </div>
          </div>
        ))}
      </div>

      {/* Horizontal Cards Section */}
      <div className="card-container_CC">
        {cardData.map((card, index) => (
          <div key={index} className="card_CC">

            <div className="card-details">
              <h2 className="service-title">{card.serviceName}</h2>

              {card.serviceMethod && (
                <p>
                  <strong>Service Method:</strong> {card.serviceMethod}
                </p>
              )}

              {card.serviceTimes.map((time, i) => (
                <p key={i}>
                  <strong>Service Time:</strong> {time}
                </p>
              ))}

              <div className="officers-section">
                {card.officers.map((officer, idx) => (
                  <div className="officer-card">
                    {officer.img && (
                      <div className="profile">
                        <img src={officer.img} alt={officer.name} />
                      </div>
                    )}

                    <div className="officer-info">
                      <h3>{officer.name}</h3>
                      <p>{officer.position}</p>
                      <a href={`tel:${officer.phone}`}>{officer.phone}</a>
                      <br />
                      <a href={`mailto:${officer.email}`}>{officer.email}</a>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CitizenCharter;
